import * as React from 'react';
import ChevronDown from '@uber/base-icons/chevron-down';
import { type Theme, useStyletron } from 'baseui';
type ColorSwatchButtonPropsT = {
  color: string;
  onClick?: () => void;
};
const getContainerStyles = (theme: Theme) => ({
  display: ('flex' as const),
  alignItems: ('center' as const),
  gap: theme.sizing.scale100,
  width: theme.sizing.scale1600,
  height: theme.sizing.scale1200,
  justifyContent: ('center' as const),
  background: 'none',
  border: 'none',
  cursor: ('pointer' as const),
  padding: '0',
  flexShrink: 0
});
const getSwatchStyles = (color: string, theme: Theme) => ({
  width: theme.sizing.scale500,
  height: theme.sizing.scale500,
  borderRadius: theme.borders.radius100,
  backgroundColor: color,
  flexShrink: 0
});
export function ColorSwatchButton({
  color,
  onClick
}: ColorSwatchButtonPropsT) {
  const [css, theme] = useStyletron();
  return <button className={css(getContainerStyles(theme))} onClick={onClick} data-testid="color-swatch-button">
      <div className={css(getSwatchStyles(color, theme))} />
      <ChevronDown size={16} />
    </button>;
}